import store from "..";
import _ from "lodash";
import UserService from "../../services/UserService";
import SubscriptionService from "../../services/SubscriptionService";

// GET /teams is the session-wide team list (sidebar switcher). If that payload
// already includes members, the Team page can reuse it instead of GET /my-teams.
const ownerTeamsFromMemberDetails = (teams) => {
  if (!Array.isArray(teams)) return [];
  return teams
    .filter((t) => t && Array.isArray(t.members))
    .map((t) => ({
      ...t,
      _id: t._id || t.id,
    }));
};

const defaultState = () => ({
  id: null,
  name: "",
  email: "",
  contacts: [],
  username: "",
  joinDate: "",
  cmsEntityId: "",
  isOtt: null,
  apiKey: null,
  aggregatedDefinition: {},
  subscriptions: [],
  memberDetails: [],
  ownerDetails: [],
  baseSub: [],
  addonSub: [],
  products: [],
  deploymentRegions: [],
  guestData: [],
  activatedTeam: "",
  ownermember: [],
  memberDeleted: false,
  memberDisabled: false,
  memberPermission: null,
  userloaded: false,
  isLoading: false,
  memberDetailsLoaded: false,
  memberDetailsLoading: false,
  ownerInfoLoaded: false,
  ownerInfoLoading: false,
  isOwner: true,
  viewShowcase: false,
  editShowcase: false,
  parentAccount: null,
  subscriptionMeta: {},
  maxVodItems: 0,
  maxVodStorage: 0,
  maxVodBandwidth: 0,
  maxTvPlayoutLoopDate: 0,
  tvPlayoutLineUpMode: false,
  tvPlayoutDailyMode: false,
  tvPlayoutWeeklyMode: false,
  maxSubSecondStreams: 0,
  tvPlayoutLineUpDuration: 0,
  tvPlayoutMaxUploadFileGB: 1,
  tvPlayoutMaxUploadFilesNum: 20,
  tvPlayoutMaxUploadFileDurationMin: 30,
  tvPlayoutAllowedFpsList: "25",
  tvPlayoutAllowedResolution: 720,
  reusableDestinations: null,
  reusableDestinationLimit: 0,
  teamOwnerInfoDetailed: null,
  teamMemberUser: null,
  _contactsLoading: false,
  // 2FA belongs to the signed-in user (not the team owner). Default false so the
  // Security page doesn't flash the wrong CTA before loadUser resolves.
  twoFactorEnabled: false,
  // Same rule as 2FA: password login is the signed-in user's own setting.
  passwordLoginEnabled: false,
});

const state = defaultState();

const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  LOAD_USER(state, user) {
    state = Object.assign(state, user);
    if (user.activeTeam) {
      state.isOwner = false;
    } else state.isOwner = true;
    state.userloaded = true;
    state.isLoading = false;
  },
  LOAD_API_KEY(state, apiKey) {
    state.apiKey = apiKey;
  },
  CHECK_OTT(state, isott) {
    state.isOtt = isott;
  },
  MEMBER_DELETED(state, memberDeleted) {
    state.memberDeleted = true;
  },
  MEMBER_DISABLED(state, memberDeleted) {
    state.memberDisabled = true;
  },
  UPDATE_MEMBERPERMISSION(state, info) {
    state.memberPermission = info;
  },
  UPDATE_TEAMINFOMEMBER(state, info) {
    state.memberDetails = info || [];
    state.memberDetailsLoaded = true;
    state.memberDetailsLoading = false;
  },
  SET_MEMBER_DETAILS_LOADING(state, loading) {
    state.memberDetailsLoading = loading;
  },
  SET_OWNER_INFO_LOADING(state, loading) {
    state.ownerInfoLoading = loading;
  },
  SET_OWNER_INFO_LOADED(state, loaded) {
    state.ownerInfoLoaded = loaded;
  },
  UPDATE_GUEST(state, info) {
    state.guestData = info;
    if (info?.paywall) {
      state.paywall = info.paywall;
    }
  },
  UPDATE_TEAMINFOOWNER(state, info) {
    state.ownerDetails = info;
  },
  UPDATE_OWNER(state, info) {
    state.ownermember = info;
  },
  UPDATE_USER(state, user) {
    state.userDetails = user;
  },
  UPDATE_ACTIVETEAM(state, team) {
    state.activatedTeam = team;
  },
  /* eslint-disable-next-line no-unused-vars */
  UNLOAD_USER(state) {
    state = defaultState();
  },
  SET_DEFAULT_USER() {
    let currentState = this.state.User;
    let allowedState = Object.keys(defaultState());
    const filteredState = Object.keys(currentState)
      .filter((key) => allowedState.includes(key))
      .reduce((obj, key) => {
        obj[key] = currentState[key];
        return obj;
      }, {});
    this.state.User = filteredState;
    this.state.User.memberDetailsLoaded = false;
    this.state.User.memberDetailsLoading = false;
    this.state.User.ownerInfoLoaded = false;
    this.state.User.ownerInfoLoading = false;
  },
  SET_CONTACTS(state, contacts) {
    state.contacts = contacts;
  },
  SET_CONTACTS_LOADING(state, loading) {
    state._contactsLoading = loading;
  },
  UNLOAD_PAYWALL(state) {
    delete state.paywall;
  },
  SET_PAYWALL_LINKED(state, linked) {
    if (state.paywall) {
      state.paywall.linked = linked;
    }
  },
  UPDATE_MEMBER_DETAILS(state, details) {
    state.teamMemberUser = details;
  },
  UPDATE_ADDON_SUB_USAGE(state, data) {
    const pkgId = data.sub?.package?._id
    const patch = (subscription) => {
      if (!subscription) return
      if (data.phoneAlerts) {
        subscription.usage = {
          ...(subscription.usage ?? {}),
          phoneAlerts: data.phoneAlerts,
        }
      }
      if (data.bandwidth) {
        subscription.usage = {
          ...(subscription.usage ?? {}),
          bandwidth: data.bandwidth,
        }
      }
      if (data.storage) {
        subscription.usage = {
          ...(subscription.usage ?? {}),
          storage: data.storage,
        }
      }
    }
    patch((state.addonSub || []).find((sub) => sub?.package?._id === pkgId))
    if (state.baseSub?.package?._id === pkgId) patch(state.baseSub)
    state.subscriptions.forEach((sub) => {
      if (sub?.package?._id === pkgId) patch(sub)
    })
  },
  UPDATE_BASE_SUB_USAGE(state, data) {
    const subscription = state.baseSub;
    if (data.phoneAlerts && subscription) {
      subscription.usage = {
        ...(subscription.usage ?? {}),
        phoneAlerts: data.phoneAlerts,
      };
    }
    if (data.bandwidth && subscription) {
      subscription.usage = {
        ...(subscription.usage ?? {}),
        bandwidth: data.bandwidth,
      };
    }
    if (data.storage && subscription) {
      subscription.usage = {
        ...(subscription.usage ?? {}),
        storage: data.storage,
      };
    }
  },
  SET_TWO_FACTOR_ENABLED(state, data) {
    state.twoFactorEnabled = data;
  },
  SET_PASSWORD_LOGIN_ENABLED(state, data) {
    state.passwordLoginEnabled = data;
  },
};

const actions = {
  async loadUser({ commit, state }, forceRefresh = false) {
    // If user is already loaded and not forcing refresh, skip
    if (state.userloaded && !forceRefresh) {
      return;
    }
    
    // If currently loading, wait for it
    if (state.isLoading) {
      return new Promise((resolve) => {
        const checkLoading = setInterval(() => {
          if (!state.isLoading) {
            clearInterval(checkLoading);
            resolve();
          }
        }, 50);
      });
    }
    
    commit("SET_LOADING", true);
    
    try {
      let userProfile = await UserService.getUserInfo(!!forceRefresh);
      // Capture 2FA from /users/me BEFORE any team-owner swap. For team members the
      // final LOAD_USER payload is the owner's profile, which must not overwrite the
      // signed-in user's own twoFactorEnabled flag.
      const signedInTwoFactorEnabled = !!userProfile?.twoFactorEnabled;
      const signedInPasswordLoginEnabled = !!userProfile?.passwordLoginEnabled;
      let userOwnerProfile = null;
      let userteam = userProfile.activeTeam;
      let userSub = await SubscriptionService.getUserSubscriptions(true);
      if (userProfile) {
        commit("UPDATE_MEMBER_DETAILS", userProfile);
      }
      if (userteam) {
        commit("LOAD_USER", {
          ...userProfile,
          parentAccount: userProfile.parentAccount,
        });
        try {
          const permission = await UserService.getMemberpermission(
            userteam,
            userProfile._id
          );
          commit("UPDATE_MEMBERPERMISSION", permission);
          if (!permission.isEnabled) commit("MEMBER_DISABLED");
        } catch (err) {
          console.log(err);
          if (
            this.state.User.memberPermission &&
            !this.state.User.memberPermission.isEnabled
          ) {
            commit("MEMBER_DISABLED");
          } else {
            commit("MEMBER_DELETED");
          }
        }
        if (!this.state.User.memberDeleted) {
          try {
            const owner = await UserService.getTeamOwner(userteam, false, true);
            commit("UPDATE_GUEST", owner);
          } catch (err) {
            console.log(err);
          }
        }
        const userSubdata = await UserService.getTeamOwner(userteam);
        userSub = userSubdata.subscription;
        userOwnerProfile = userSubdata.owner;
        userOwnerProfile.activeTeam = userProfile.activeTeam;
        userOwnerProfile._id = userProfile._id;
        userProfile = userOwnerProfile;
        UserService.setOwnerSession(userSubdata);
      } else {
        UserService.setOwnerSession(null);
      }

      const userPlans = _.concat(
        userSub.addonSubscriptions,
        userSub.subscription ? [userSub.subscription] : []
      );

      // base sub info
      const subscriptionMeta = {};
      const live = userPlans.find(
        (sub) => sub.category && sub.category.includes("live")
      );
      if (live) {
        subscriptionMeta.live = {
          trial: live.package.baseCharge === 0,
          enabled: live.enabled,
        };
      }
      const scheduled = userPlans.find(
        (sub) => sub.category && sub.category.includes("scheduled")
      );
      if (scheduled) {
        subscriptionMeta.scheduled = {
          trial: scheduled.package.baseCharge === 0,
          enabled: scheduled.enabled,
        };
      }

      const vod = userPlans.find(
        (sub) => sub.category && sub.category.includes("vod")
      );
      if (vod) {
        subscriptionMeta.vod = {
          trial: vod.package.baseCharge === 0,
          enabled: vod.enabled,
        };
      }

      const aggregatedDefinition = {
        live: livePlanFeatures(userSub.addonSubscriptions),
        vod: vodPlanFeatures(userSub.addonSubscriptions),
        scheduled: schedulePlanFeatures(userSub.addonSubscriptions),
        subsecond: livePlanFeatures(userSub.addonSubscriptions),
      };
      commit("LOAD_USER", {
        ...userProfile,
        subscriptionMeta: subscriptionMeta,
        aggregatedDefinition: aggregatedDefinition,
        subscriptions: userPlans,
        addonSub: userSub.addonSubscriptions,
        baseSub: userSub.subscription,
        deploymentRegions: userSub.deploymentRegions || [],
        maxVodItems: userSub.maxVodItems,
        maxVodStorage: userSub.maxVodStorage,
        maxVodBandwidth: userSub.maxVodBandwidth,
        activatedTeam: userProfile.activeTeam,
        tvPlayoutLineUpMode: userSub.tvPlayoutLineUpMode,
        tvPlayoutDailyMode: userSub.tvPlayoutDailyMode,
        tvPlayoutWeeklyMode: userSub.tvPlayoutWeeklyMode,
        maxTvPlayoutItems: userSub.maxTvPlayoutItems,
        maxSubSecondStreams: userSub.maxSubSecondStreams,
        maxSubSecondStreamViewers: userSub.maxSubSecondStreamViewers,
        maxTvPlayoutLoopDate: userSub.maxTvPlayoutLoopDate,
        reusableDestinations: userSub.reusableDestinations,
        reusableDestinationLimit: userSub.reusableDestinationLimit,
        allowSubSecondStreams: userSub.allowSubSecondStreams,
        v2ApiKey: userSub.v2ApiKey,
        advancedTvPlayoutSettingsFps: userSub.advancedTvPlayoutSettingsFps,
        advancedTvPlayoutSettingsResolution: userSub.advancedTvPlayoutSettingsResolution,
        tvPlayoutLineUpDuration: userSub.tvPlayoutLineUpDuration,
        tvPlayoutMaxUploadFileGB: userSub.tvPlayoutMaxUploadFileGB ?? 1,
        tvPlayoutMaxUploadFilesNum: userSub.tvPlayoutMaxUploadFilesNum ?? 20,
        tvPlayoutMaxUploadFileDurationMin:
          userSub.tvPlayoutMaxUploadFileDurationMin ?? 30,
        tvPlayoutAllowedFpsList: userSub.tvPlayoutAllowedFpsList ?? "25",
        tvPlayoutAllowedResolution: userSub.tvPlayoutAllowedResolution ?? 720,
        tvPlayoutLoopMode: userSub.tvPlayoutLoopMode,
        tvPlayoutScheduleMode: userSub.tvPlayoutScheduleMode,
        // Always the signed-in account's 2FA, never the team owner's.
        twoFactorEnabled: signedInTwoFactorEnabled,
        passwordLoginEnabled: signedInPasswordLoginEnabled,
        // viewShowcase: userProfile.viewShowcase,
        // editShowcase: userProfile.editShowcase,
      });
      commit("SET_TWO_FACTOR_ENABLED", signedInTwoFactorEnabled);
      commit("SET_PASSWORD_LOGIN_ENABLED", signedInPasswordLoginEnabled);
    } catch (error) {
      console.log(error);
      commit("SET_LOADING", false);
    }
  },
  async setupUserContacts({ commit, state }) {
    // If contacts already loaded, skip
    if (state.contacts && state.contacts.length > 0) {
      return state.contacts;
    }
    
    // Check if currently loading (basic check)
    if (state._contactsLoading) {
      return new Promise((resolve) => {
        const checkLoading = setInterval(() => {
          if (!state._contactsLoading) {
            clearInterval(checkLoading);
            resolve(state.contacts);
          }
        }, 50);
      });
    }
    
    commit("SET_CONTACTS_LOADING", true);
    try {
      const contacts = await UserService.getUserContacts("phone");
      commit("SET_CONTACTS", contacts);
      commit("SET_CONTACTS_LOADING", false);
      return contacts;
    } catch (err) {
      console.log(err);
      commit("SET_CONTACTS_LOADING", false);
      throw err;
    }
  },
  async unloadUser({ commit }) {
    commit("UNLOAD_USER");
  },
  async setdefaultUserstate({ commit }) {
    commit("SET_DEFAULT_USER");
  },
  async loadApiKey({ commit }) {
    try {
      const { data } = await UserService.getUserApiKey();
      commit("LOAD_API_KEY", data);
    } catch (error) {
      console.log(error);
    }
  },
  async getinfoMember({ commit, state }, forceRefresh = false) {
    if (state.memberDetailsLoaded && !forceRefresh) {
      return state.memberDetails;
    }
    if (state.memberDetailsLoading) {
      return new Promise((resolve) => {
        const checkLoading = setInterval(() => {
          if (!state.memberDetailsLoading) {
            clearInterval(checkLoading);
            resolve(state.memberDetails);
          }
        }, 50);
      });
    }

    commit("SET_MEMBER_DETAILS_LOADING", true);
    try {
      const result = await UserService.teamInfoMember();
      commit("UPDATE_TEAMINFOMEMBER", result);
      return result;
    } catch (error) {
      commit("SET_MEMBER_DETAILS_LOADING", false);
      throw error;
    }
  },
  async getactiveTeam({ commit, state }) {
    // Use already-loaded user data instead of calling API again
    let userteam = state.activatedTeam;
    if (!userteam) {
      await this.dispatch('User/loadUser');
      userteam = state.activatedTeam;
    }
    commit("UPDATE_ACTIVETEAM", userteam);
  },
  async getinfoOwner({ commit, state }, forceRefresh = false) {
    if (state.ownerInfoLoaded && !forceRefresh) {
      return;
    }
    if (state.ownerInfoLoading) {
      return new Promise((resolve) => {
        const checkLoading = setInterval(() => {
          if (!state.ownerInfoLoading) {
            clearInterval(checkLoading);
            resolve();
          }
        }, 50);
      });
    }

    commit("SET_OWNER_INFO_LOADING", true);
    try {
      // Use already-loaded user data instead of calling API again
      let userteam = state.activatedTeam;
      if (!userteam) {
        await this.dispatch("User/loadUser");
        userteam = state.activatedTeam;
      }
      if (userteam) {
        try {
          const teamDetails = await UserService.getTeamOwner(userteam);
          if (userteam && teamDetails["members"].length) {
            commit("UPDATE_OWNER", teamDetails);
            commit("UPDATE_TEAMINFOOWNER", []);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        const owned = ownerTeamsFromMemberDetails(state.memberDetails);
        if (owned.length) {
          commit("UPDATE_TEAMINFOOWNER", owned);
          commit("UPDATE_OWNER", []);
        } else {
          const result = await UserService.teaminfoOwner();
          commit("UPDATE_TEAMINFOOWNER", result);
          commit("UPDATE_OWNER", []);
        }
      }
      commit("SET_OWNER_INFO_LOADED", true);
    } catch (error) {
      console.log(error);
    } finally {
      commit("SET_OWNER_INFO_LOADING", false);
    }
  },
  async checkOtt({ commit }) {
    try {
      const result = await UserService.getUserApiKey();
      commit("CHECK_OTT", result.keyType == "ott_app");
    } catch (error) {
      console.log(error);
    }
  },
  unloadPaywall({ commit }) {
    commit("UNLOAD_PAYWALL");
  },
  setPaywallLinked({ commit }, linked) {
    commit("SET_PAYWALL_LINKED", linked);
  },
  updateAddonSubUsage({ commit }, data) {
    commit("UPDATE_ADDON_SUB_USAGE", data);
  },
  updateBaseSubUsage({ commit }, data) {
    commit("UPDATE_BASE_SUB_USAGE", data);
  },
  setTwoFactorEnabled({ commit }, data) {
    commit("SET_TWO_FACTOR_ENABLED", data);
  },
  setPasswordLoginEnabled({ commit }, data) {
    commit("SET_PASSWORD_LOGIN_ENABLED", data);
  },
};

const getters = {
  userId: (state) => state._id,
  userEmail: (state) => state.email,
  userName: (state) => state.name,
  initials: (state) =>
    state.name.length
      ? state.name
          .split(" ")
          .map((s) => s[0].toUpperCase())
          .join("")
      : "",
  maxScheduledStreams: (state) => {
    let scheduledSubscription = state.addonSub.find(
      (subscription) => subscription.category === "scheduled"
    );
    if (
      scheduledSubscription &&
      scheduledSubscription.definitionOverride &&
      scheduledSubscription.definitionOverride.streams
    ) {
      return parseInt(scheduledSubscription.definitionOverride.streams, 10);
    } else if (
      scheduledSubscription &&
      scheduledSubscription.package &&
      scheduledSubscription.package.definition
    ) {
      return parseInt(scheduledSubscription.package.definition.streams, 10);
    } else return 0;
  },
  userPermissions: (state) => state.memberPermission,
  permissionSubAccountCreateView: (state) => {
    if (
      (state.memberPermission && state.memberPermission.role === "admin") ||
      (state.memberPermission &&
        state.memberPermission.role === "moderator" &&
        state.memberPermission.subAccountInfoCreate &&
        state.memberPermission.subAccountInfoView) ||
      (state.memberPermission === null && !state.activatedTeam)
    ) {
      return true;
    } else return false;
  },
  permissionSubAccountStreamsView: (state) => {
    if (
      (state.memberPermission && state.memberPermission.role === "admin") ||
      (state.memberPermission &&
        state.memberPermission.role === "moderator" &&
        state.memberPermission.subAccountStreamView) ||
      state.memberPermission === null
    ) {
      return true;
    } else return false;
  },
  // Gates the LiveU API, Developer API and vMix Token tabs. Admin permission
  // documents already have `developers` forced on by getMemberpermission.
  canAccessDevelopers: (state) => {
    return !state.activatedTeam || Boolean(state.memberPermission?.developers);
  },
  baseSubscription: (state) => {
    return state.baseSub;
  },
  addonSubscriptions: (state) => {
    return state.addonSub;
  },
  showcaseView: (state) => {
    return state.viewShowcase;
  },
  showcaseEdit: (state) => {
    return state.editShowcase;
  },
  hasSubAccountSubscription: (state) => {
    if (
      state.addonSub.find(
        (subscription) => subscription.category === "sub-accounts"
      )
    ) {
      return true;
    } else return false;
  },
  canEncodeVideos: (state) => {
    const encodingUnits = _.get(
      state.baseSub,
      "package.definition.encodingUnits"
    );
    return encodingUnits > 0;
  },
  isOwner: (state) => {
    return state.isOwner;
  },
  isTeamAdmin: (state) => {
    if (state.memberPermission && state.memberPermission.role === "admin") {
      return true;
    } else return false;
  },
  isTeamModerator: (state) => {
    if (state.memberPermission && state.memberPermission.role === "moderator") {
      return true;
    } else return false;
  },
  isSubAccount: (state) => {
    if (state.parentAccount) {
      return true;
    } else return false;
  },
  parentAccount: (state) => {
    if (state.parentAccount) {
      return state.parentAccount;
    } else return null;
  },
  teamOwner: (state) => {
    if (state.ownermember && state.ownermember.owner) {
      return state.ownermember && state.ownermember.owner;
    } else return null;
  },
  userContacts: (state) => {
    return state.contacts;
  },
  maxVodFolders: (state) => {
    return state.maxVodItems;
  },
  maxVodStorage: (state) => {
    return state.maxVodStorage;
  },
  maxVodBandwidth: (state) => {
    return state.maxVodBandwidth;
  },
  tvPlayoutLineUpMode: (state) => {
    return state.tvPlayoutLineUpMode;
  },
  tvPlayoutDailyMode: (state) => {
    return state.tvPlayoutDailyMode;
  },
  tvPlayoutWeeklyMode: (state) => {
    return state.tvPlayoutWeeklyMode;
  },
  maxTvPlayoutLoopDate: (state) => {
    return state.maxTvPlayoutLoopDate;
  },
  maxTvPlayoutItems: (state) => {
    return state.maxTvPlayoutItems;
  },
  maxSubSecondStreams: (state) => {
    return state.maxSubSecondStreams;
  },
  maxSubSecondStreamViewers: (state) => {
    return state.maxSubSecondStreamViewers;
  },
  subscriptions: (state) => {
    return state.subscriptions;
  },
  tvPlayoutLineUpDuration: (state) => {
    return state.tvPlayoutLineUpDuration;
  },
  tvPlayoutMaxUploadFileGB: (state) => {
    return state.tvPlayoutMaxUploadFileGB;
  },
  tvPlayoutMaxUploadFilesNum: (state) => {
    return state.tvPlayoutMaxUploadFilesNum;
  },
  tvPlayoutMaxUploadFileDurationMin: (state) => {
    return state.tvPlayoutMaxUploadFileDurationMin;
  },
  tvPlayoutAllowedFpsList: (state) => {
    return state.tvPlayoutAllowedFpsList;
  },
  tvPlayoutAllowedResolution: (state) => {
    return state.tvPlayoutAllowedResolution;
  },
  canDownloadSource: (state) => {
    const unlimitedDownload =
      state.addonSub.find((subscription) => subscription.category === "live")
        ?.package?.definition?.unlimitedVodDownload ||
      state?.unlimitedVodDownload;
    return unlimitedDownload;
  },
  hasMultistreamSubscription: (state) =>
    state.baseSub?.package?.category === "restream" && state.baseSub?.enabled,
  hasLiveSubscription: (state) => {
    if (state.subscriptionMeta.live) {
      return state.subscriptionMeta.live;
    } else return false;
  },
  hasPreRecordedSubscription: (state) => {
    if (state.subscriptionMeta.scheduled) {
      return state.subscriptionMeta.scheduled;
    } else return false;
  },
  hasVodSubscription: (state) => {
    if (state.subscriptionMeta.vod) {
      return state.subscriptionMeta.vod;
    } else return false;
  },
  isLiveSubscriptionExpired: (state) => {
    if (state.subscriptionMeta.live && !state.subscriptionMeta.live.enabled) {
      return true;
    } else return false;
  },
  subscriptionMeta: (state) => {
    return state.subscriptionMeta
  },
  dynamicPlayerFeatures: (state) => {
    const liveSubscription = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    const vodSubscription = state.addonSub.find(
      (subscription) => subscription.category === "vod"
    );
    if (liveSubscription) {
      const features = {
        count: liveSubscription?.package?.definition?.["dp:count"]
          ? liveSubscription?.package?.definition?.["dp:count"]
          : false,
        "domain-whitelist": liveSubscription?.package?.definition?.[
          "dp:domain-whitelist"
        ]
          ? liveSubscription?.package?.definition?.["dp:domain-whitelist"]
          : false,
        "geo-block": liveSubscription?.package?.definition?.["dp:geo-block"]
          ? liveSubscription?.package?.definition?.["dp:geo-block"]
          : false,
        "geo-whitelist": liveSubscription?.package?.definition?.[
          "dp:geo-whitelist"
        ]
          ? liveSubscription?.package?.definition?.["dp:geo-whitelist"]
          : false,
        "player-functions": liveSubscription?.package?.definition?.[
          "dp:player-functions"
        ]
          ? liveSubscription?.package?.definition?.["dp:player-functions"]
          : false,
      };
      return features;
    } else if (vodSubscription) {
      const features = {
        count: liveSubscription?.package?.definition?.["dp:count"]
          ? liveSubscription?.package?.definition?.["dp:count"]
          : false,
        "domain-whitelist": liveSubscription?.package?.definition?.[
          "dp:domain-whitelist"
        ]
          ? liveSubscription?.package?.definition?.["dp:domain-whitelist"]
          : false,
        "geo-block": liveSubscription?.package?.definition?.["dp:geo-block"]
          ? liveSubscription?.package?.definition?.["dp:geo-block"]
          : false,
        "geo-whitelist": liveSubscription?.package?.definition?.[
          "dp:geo-whitelist"
        ]
          ? liveSubscription?.package?.definition?.["dp:geo-whitelist"]
          : false,
        "player-functions": liveSubscription?.package?.definition?.[
          "dp:player-functions"
        ]
          ? liveSubscription?.package?.definition?.["dp:player-functions"]
          : false,
      };
      return features;
    } else return false;
  },
  maxTranscoders: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const maxTranscodersSub = liveSub?.package?.definition?.maxTranscoders ?? 0;
    const maxTranscodersOverride = liveSub?.definitionOverride?.maxTranscoders;

    return maxTranscodersOverride !== undefined
      ? maxTranscodersOverride
      : maxTranscodersSub;
  },
  maxMultiviews: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const maxMultiviewsSub = liveSub?.package?.definition?.maxMultiviews ?? 0;
    const maxMultiviewsOverride = liveSub?.definitionOverride?.maxMultiviews;

    return maxMultiviewsOverride !== undefined
      ? maxMultiviewsOverride
      : maxMultiviewsSub;
  },
  maxPlaylistCount: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const maxPlaylistCountSub =
      liveSub?.package?.definition?.maxPlaylistCount ?? 0;
    const maxPlaylistCountOverride =
      liveSub?.definitionOverride?.maxPlaylistCount;

    return maxPlaylistCountOverride !== undefined
      ? maxPlaylistCountOverride
      : maxPlaylistCountSub;
  },
  maxMediaflows: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const maxMediaflowsSub = liveSub?.package?.definition?.maxMediaflowNum ?? 0;
    const maxMediaflowsOverride = liveSub?.definitionOverride?.maxMediaflowNum;
    
    return maxMediaflowsOverride !== undefined
      ? maxMediaflowsOverride
      : maxMediaflowsSub;
  },
  maxMediaflowFlows: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const maxMediaflowsSub = liveSub?.package?.definition?.maxMediaflowFlowNum ?? 0;
    const maxMediaflowsOverride = liveSub?.definitionOverride?.maxMediaflowFlowNum;
    
    return maxMediaflowsOverride !== undefined
      ? maxMediaflowsOverride
      : maxMediaflowsSub;
  },
  maxMediaflowMedia: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const maxMediaflowsSub = liveSub?.package?.definition?.maxMediaflowMediaNum ?? 0;
    const maxMediaflowsOverride = liveSub?.definitionOverride?.maxMediaflowMediaNum;
    
    return maxMediaflowsOverride !== undefined
      ? maxMediaflowsOverride
      : maxMediaflowsSub;
  },
  mediaflowResolution: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const maxMediaflowsSub = liveSub?.package?.definition?.mediaflowResolution ?? 720;
    const maxMediaflowsOverride = liveSub?.definitionOverride?.mediaflowResolution;
    
    return maxMediaflowsOverride !== undefined
      ? maxMediaflowsOverride
      : maxMediaflowsSub;
  },
  mediaflowTrial: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const maxMediaflowsSub = liveSub?.package?.definition?.mediaflowTrial ?? false;
    const maxMediaflowsOverride = liveSub?.definitionOverride?.mediaflowTrial;
    
    return maxMediaflowsOverride !== undefined
      ? maxMediaflowsOverride
      : maxMediaflowsSub;
  },
  transcoderFlag: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const transcodersSub = liveSub?.package?.definition?.transcoder;
    const transcodersOverride = liveSub?.definitionOverride?.transcoder;

    return transcodersOverride !== undefined
      ? transcodersOverride
      : transcodersSub;
  },
  drmProtectionFlag: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const drmProtectionSub = liveSub?.package?.definition?.drmProtection;
    const drmProtectionOverride = liveSub?.definitionOverride?.drmProtection;

    return drmProtectionOverride !== undefined
      ? drmProtectionOverride
      : drmProtectionSub;
  },
  mediaflowFlag: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const mediaflowsSub = liveSub?.package?.definition?.mediaflow;
    const mediaflowsOverride = liveSub?.definitionOverride?.mediaflow;

    return mediaflowsOverride !== undefined
      ? mediaflowsOverride
      : mediaflowsSub;
  },
  mediaflowAllowedFpsList: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const mediaflowsSub = liveSub?.package?.definition?.mediaflowAllowedFpsList;
    const mediaflowsOverride = liveSub?.definitionOverride?.mediaflowAllowedFpsList;

    return mediaflowsOverride !== undefined
      ? mediaflowsOverride
      : mediaflowsSub;
  },
  mediaflowAdSchedule: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const maxMediaflowsSub = liveSub?.package?.definition?.mediaflowAdSchedule ?? false;
    const maxMediaflowsOverride = liveSub?.definitionOverride?.mediaflowAdSchedule;
    
    return maxMediaflowsOverride !== undefined
      ? maxMediaflowsOverride
      : maxMediaflowsSub;
  },
  maxMediaflowAdSchedule: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const maxMediaflowsSub = liveSub?.package?.definition?.maxMediaflowAdSchedule ?? 0;
    const maxMediaflowsOverride = liveSub?.definitionOverride?.maxMediaflowAdSchedule;
    
    return maxMediaflowsOverride !== undefined
      ? maxMediaflowsOverride
      : maxMediaflowsSub;
  },
  securityWhitelistPage: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const sub =
      liveSub?.package?.definition?.["security:domain-whitelist-page"];
    const override =
      liveSub?.definitionOverride?.["security:domain-whitelist-page"];

    return override !== undefined ? override : sub;
  },
  hasTranscoderWatermarkFeature: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }
    const allowedPlans = [
      "643502dd40771d569f1e98f0", // Ultra Monthly - legacy
      "6435044340771d569f1e98fa", // Ultra Yearly - legacy
      "698d84497375f3f790ec54b5", // Ultra Monthly
      "698d845b7375f3f790ec54b6", // Ultra Early
      "698d83927375f3f790ec54b1", // Event Monthly
      "698d839e7375f3f790ec54b2", // Event Yearly
      "65c46f59883348e523b6de0d", // Custom Plan
      "679ba8af7570870676312f8f"  // Custom Plan
    ];
    return allowedPlans.includes(liveSub?.package?._id);
  },
  hasFailoverIngestFeature: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return false;
    }

    const failoverIngestSub = liveSub?.package?.definition?.failoverIngest;
    const failoverIngestOverride = liveSub?.definitionOverride?.failoverIngest;

    return failoverIngestOverride !== undefined
      ? failoverIngestOverride
      : failoverIngestSub;
  },
  userPaywall: (state) => {
    return state.paywall;
  },
  userPaywallActived: (state) => {
    return state?.paywall?.linked ?? state.guestData?.paywall?.linked ?? false;
  },
  hasDestinations: (state) => {
    return state.reusableDestinations;
  },
  hasDestinationLimit: (state) => {
    return state.reusableDestinationLimit;
  },
  maxPaywalls: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const maxPaywallsSub = liveSub?.package?.definition?.maxPaywalls ?? 0;
    const maxPaywallsOverride = liveSub?.definitionOverride?.maxPaywalls;

    return maxPaywallsOverride !== undefined
      ? maxPaywallsOverride
      : maxPaywallsSub;
  },
  paywallStripeCommission: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const commissionSub =
      liveSub?.package?.definition?.paywallStripeCommission ?? null;
    const commissionSubOverride =
      liveSub?.definitionOverride?.paywallStripeCommission;

    return commissionSubOverride !== undefined
      ? commissionSubOverride
      : commissionSub;
  },
  // Sites plan gate — same live-package definition/override pattern as paywall.
  // Same rule as castr's resolveSitesCaps: a positive maxSites (package or
  // definitionOverride) enables Sites; the generic `sites` flag is not read.
  hasSitesFeature: (state, getters) => Number(getters.maxSites) > 0,
  maxSites: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return 0;
    }

    const maxSitesSub = liveSub?.package?.definition?.maxSites ?? 0;
    const maxSitesOverride = liveSub?.definitionOverride?.maxSites;

    return maxSitesOverride !== undefined ? maxSitesOverride : maxSitesSub;
  },
  bitradeLadderFlag: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const bitrateLadderSub = liveSub?.package?.definition?.bitrateLadder;
    const bitrateLadderOverride = liveSub?.definitionOverride?.bitrateLadder;

    return bitrateLadderOverride !== undefined
      ? bitrateLadderOverride
      : bitrateLadderSub;
  },
  audioBitrateLadderFlag: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );
    if (!liveSub) {
      return;
    }

    const sub = liveSub?.package?.definition?.audioBitrateLadder;
    const subOverride = liveSub?.definitionOverride?.audioBitrateLadder;

    return subOverride !== undefined ? subOverride : sub;
  },
  v2ApiKey: (state) => {
    return state.v2ApiKey;
  },
  hasPlayoutAdvancedSettings: (state) => {
    return (
      state.advancedTvPlayoutSettingsFps ||
      state.advancedTvPlayoutSettingsResolution
    );
  },
  hasPlayoutSettingsFps: (state) => {
    return state.advancedTvPlayoutSettingsFps;
  },
  hasPlayoutSettingsResolution: (state) => {
    return state.advancedTvPlayoutSettingsResolution;
  },
  livePlanPackageId: (state) => {
    return state.addonSub.find(
      (subscription) => subscription.category === "live"
    )?.package?._id;
  },
  hasPlayoutLoopMode: (state) => {
    return state.tvPlayoutLoopMode;
  },
  hasPlayoutScheduleMode: (state) => {
    return state.tvPlayoutScheduleMode;
  },
  playoutMaxDurationLimit: (state) => {
    const liveSub = state.addonSub.find(
      (subscription) => subscription.category === "live"
    );

    const sub = liveSub?.package?.definition?.tvPlayoutLineUpDuration;
    const subOverride = liveSub?.definitionOverride?.tvPlayoutLineUpDuration;

    const resolved = subOverride !== undefined ? subOverride : sub;
    return resolved !== undefined ? resolved : state.tvPlayoutLineUpDuration;
  },
  userLoaded: (state) => state.userloaded,
  ownerInfoLoaded: (state) => state.ownerInfoLoaded,
  memberDetailsLoaded: (state) => state.memberDetailsLoaded,
  memberDetails: (state) => state.memberDetails,
  activeTeam: (state) =>
    state.memberDetails.find((team) => team.id === state.activeTeam),
  isTrialSubscription: (state) => {
    const subs = state.subscriptions.map((sub) =>
      _.assign({ category: "restream" }, sub)
    );
    const baseSub = _.find(subs, { category: "live" }) || {};
    return /trial/gi.test(baseSub.package.name) || false;
  },
  deploymentRegions: (state) => state.deploymentRegions,
  overageBypass: (state) => state.overageBypass,
  twoFactorEnabled: (state) => state.twoFactorEnabled,
  passwordLoginEnabled: (state) => state.passwordLoginEnabled
};

function livePlanFeatures(addonSub) {
  const sub = _.find(addonSub, { category: "live" });
  if (sub) {
    if (sub.package.name.includes("All-In-One")) {
      const features = [
        ["password-auth", "securityFeaturesPasswordAuth"],
        ["geo-block", "securityFeaturesGeoBlock"],
        ["geo-whitelist", "securityFeaturesGeoWhitelist"],
        ["domain-whitelist", "securityFeaturesDomainWhitelist"],
      ];

      // all blocked by default
      const result = {
        securityFeaturesPasswordAuth: true,
        securityFeaturesGeoBlock: true,
        securityFeaturesGeoWhitelist: true,
        securityFeaturesDomainWhitelist: true,
      };

      _.forEach(features, ([dbName, newName]) => {
        const hasFeature =
          _.get(sub, `package.definition.security:${dbName}`) === true;
        result[newName] = !hasFeature;
      });

      return result;
    }

    const planFeatures = {
      paywall: _.get(sub, "package.definition.paywall") === true,
      varyingRewind: _.get(sub, "package.definition.varyingRewind") === true,
      delayingStream: _.get(sub, "package.definition.delayingStream") === true,
      llHls: _.get(sub, "package.definition.llHls") === true,
    };
    const bw = _.get(sub, "package.definition.bandwidth");
    if (bw < 1000) {
      // disable domain whitelisting for this package
      planFeatures["securityFeaturesDomainWhitelist"] = true;
    }

    return planFeatures;
  }
  return {};
}

function vodPlanFeatures(addonSub) {
  const features = [
    ["password-auth", "securityFeaturesPasswordAuth"],
    ["geo-block", "securityFeaturesGeoBlock"],
    ["geo-whitelist", "securityFeaturesGeoWhitelist"],
    ["domain-whitelist", "securityFeaturesDomainWhitelist"],
  ];

  let result = {
    securityFeaturesPasswordAuth: true,
    securityFeaturesGeoBlock: true,
    securityFeaturesGeoWhitelist: true,
    securityFeaturesDomainWhitelist: true,
    paywall: true,
  };
  _.forEach(addonSub, (sub) => {
    if (
      sub.category === "vod" ||
      (sub.package.definition.maxVodItems &&
        parseInt(sub.package.definition.maxVodItems, 10) > 0)
    ) {
      // explicity check if paywall feature in sub, by default paywall for VOD active
      if (_.has(sub, "package.definition.paywall")) {
        result.paywall = _.get(sub, "package.definition.paywall");
      }

      _.forEach(features, ([dbName, newName]) => {
        const hasFeature =
          _.get(sub, `package.definition.security:${dbName}`) === true;
        // Now vod is a feature in other category (live, restream)
        // We define 2 security for main category & for vod, so need to check the security:vod:featureName
        const hasFeatureVod =
          _.get(sub, `package.definition.security:vod:${dbName}`) === true;
        if (hasFeature || hasFeatureVod) {
          result[newName] = false;
        }
      });
    }
  });
  return result;
}

function schedulePlanFeatures(addonSub) {
  const sub = _.find(addonSub, { category: "scheduled" }) || [];
  const features = [
    ["loopingFeature", "loopingFeature"],
    ["multifiles", "multifiles"],
  ];

  const featureList = _.reduce(
    features,
    (acc, [dbName, newName]) => {
      const hasFeature = _.get(sub, `package.definition.${dbName}`) === true;
      acc[newName] = false;
      if (!hasFeature) {
        acc[newName] = true;
      }
      return acc;
    },
    {}
  );

  return featureList;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
